import { message } from 'antd'
import { messageTypes } from '../constants/messageTypes'

export const showMessage = (messageText: string | string[], type: messageTypes) => {
  if (Array.isArray(messageText)) {
    return messageText.map((text) => message[type](text, 3))
  }
  return message[type](messageText, 3)
}
